import HeroContainer from "../components/common/HeroContainer"
import PaymentsReports from "../components/invoicing/Payments/PaymentsReports"

const PaymentsPage = () => {
  return <>
    <HeroContainer imgSrc="" />
    <div className="hero-details">
      <h1>Payments</h1>
    </div>
    <section>
      <PaymentsReports />
    </section>
  </>
}

export default PaymentsPage